import React, { useContext } from 'react'
import { FormDataNewsContext, ShowNewsContext, imageFormatsAllowed, modalType, videoFormatsAllowed } from '../types'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { useTranslation } from 'react-i18next'
import { InputImages } from '../../../HtmlComponents/InputImages'
import { TextAreaElement } from '../../../HtmlComponents/TextAreaElement'

const InputsNews = () => {
  const {
    title, setTitle,
    content, setContent,
    images, setImages,

  } = useContext(FormDataNewsContext)

  const { t } = useTranslation()

  const { selectedModal } = useContext(ShowNewsContext)

  return (
    <>
      <InputElement name={t("titre")} value={title} setValue={setTitle}/>
      <TextAreaElement name={t("Contenue")} value={content} setValue={setContent}/>
      {/* <InputElement name={t("Contenue")} value={content} setValue={setContent}/> */}
      {selectedModal === modalType.AddModal && 
        <InputImages name="photos" setImages={setImages} />      
        // <InputImages name="photos" setImages={setImages} accept="image/*" />      
      }
      <div className="grid grid-cols-4 gap-2">
        {images?.length > 0 && selectedModal === modalType.AddModal && 
          images.map((img: any, index: number) => {
            if(imageFormatsAllowed.includes(img.type?.split("/")[1])) {
              return <img
                className="w-32 h-32"
                key={index}
                src={URL.createObjectURL(img)}
                alt={`${index + 1}`}
              />
            }  
            if(videoFormatsAllowed.includes(img.type?.split("/")[1])) {
              return <video className='w-100 h-100' id="myVideo" controls key={index}>
              <source src={URL.createObjectURL(img)} type={`video/${img.type?.split(".")[1]}`} />
            </video>
            }
            return null
          })}
      </div>
    </>
  )
}

export default InputsNews